import { createApiAction } from '@app/packages/api/utils'
import type { ApiRegion, ApiSchool } from '@app/packages/api/v2/types/entities'

export const getSchools = () =>
  createApiAction('getSchools', dispatch => dispatch<{ data: ApiSchool[]; included?: ApiRegion[] }>({ method: 'GET', endpoint: '/api/v2/schools' }))
